<template>
  <v-form>
    <v-card flat class="pa-5 mb-5">
      <v-card-text>
        <v-row wrap class="mx-2">
          <v-col v-for="(field, i) in field" class="my-2 py-0" :key="i" v-bind="field.grid" v-show="field.vshow == null ? true : field.vshow">
            <component :id="field.model" v-if="field.component == 'VRadioGroup'" :is="field.component" v-model="model[field.model]" :class="field.class">
              <template v-slot:label>
                <div>{{ field.properties.label }}</div>
              </template>
              <v-radio :id="`${field.model}-${index}`" v-for="(pilih, index) in field.pilihan" :key="index" :value="pilih.value">
                <template v-slot:label>
                  <div>{{ pilih.keterangan }}</div>
                </template>
              </v-radio>
            </component>
            <template v-else-if="field.component == 'VSwitch'">
              <v-switch :id="field.model" v-if="!field.conditional ? true : field.conditional.cond" v-model="model[field.model]" v-bind="field.properties"></v-switch>
            </template>
            <template v-else-if="field.component == 'm-button'">
              <m-button
                :isBlock="field.properties.isBlock"
                :disabled="field.properties.disabled"
                depressed
                :color="field.properties.color"
                :textButton="field.properties.textButton"
                :class="field.class"
              ></m-button>
            </template>
            <template v-else>
              <template :id="field.model" v-if="field.component == 'datetime' || field.component == 'wysiwyg'">
                <span :id="field.model">{{ field.properties.label }}</span>
              </template>
              <template>
                <component
                  :is="field.component"
                  outlined
                  dense
                  :id="field.model"
                  :valueZone="field.properties.valueZone"
                  :zone="field.properties.zone"
                  v-bind="field.properties"
                  v-model="model[field.model]"
                  :data-vv-name="field.validation && field.validation.dataVvName ? field.validation.dataVvName : ''"
                  :data-vv-as="field.validation && field.validation.dataVvAs ? field.validation.dataVvAs : ''"
                  v-validate="field.validation && field.validation.vValidate ? field.validation.vValidate : ''"
                  :class="field.class"
                  :items="data[field.items]"
                  :error-messages="field.validation && field.validation.errorMessages ? errors.collect(field.validation.errorMessages) : ''"
                  v-if="!field.conditional ? true : field.conditional.cond"
                  @change="change(model[field.params])"
                >
                </component>
              </template>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
export default {
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  props: {
    field: {
      type: Array,
      default: () => []
    },
    refer: {
      type: String,
      default: ""
    },
    model: Object,
    data: Object
  },
  methods: {
    change(val) {
      this.$emit("event", val);
    }
  }
};
</script>
<style></style>
